module.exports = __webpack_public_path__ + "static/media/frame.ae310935.png";